import {mapGetters, mapActions} from 'vuex';
import CategorySelect from '@/modules/catalog/select-category/index.vue'
import productCard from '@/modules/catalog/product-card/index.vue'
import mobileCategory from '@/assets/mobile-category/index.vue'
import _ from "lodash";

export default {
    name: 'catalog',
    components: {
        CategorySelect,
        productCard,
        mobileCategory
    },
    data() {
        return {
            checkedFilter: false,
            sort: {},
            currentId: '',
            selectPriceFilter: false,
            selectFilter: {
                orderField: 'default',

            },
            selectPrice: {
                orderField: 'price',
                orderBy: ''
            },
            payload: {
                category: '',
                seller: '',
                skip: 0,
                limit: 9,
            },

        }
    },
    methods: {
        ...mapActions({
            fetchList: `category/GET_LIST`,
            fetchProducts: `category/GET_LIST_CATEGORY`,
        }),
        loadMore() {
            this.payload.skip += this.payload.limit;
            this.sendRequest();
        },
        checkFilter() {
            return this.checkedFilter = !this.checkedFilter
        },
        clearActiveClass() {
            let active = document.querySelector('.active')
            active.classList.remove('active')
        },
        selectFilters() {
            // Ensure we preserve the category and seller from the route query
            let params = _.assign({}, this.$route.query, this.selectPrice, this.selectFilter);

            // Reset skip to 0 for new filters
            this.payload.skip = 0;

            // Use Vue Router to update the URL
            this.$router.push({
                path: this.$route.path,
                query: params
            }).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    throw err;
                }
            });

            // Only call sendRequest if we're not in a route change handler
            // to prevent infinite loops
            if (!this._isRouteChangeHandling) {
                this.sendRequest();
            }

            // Reset only selectFilter, keep selectPrice.orderBy
            this.selectFilter = {
                orderField: 'default'
            };
        },
        toggleOverlay: function () {
            const overlay = document.querySelector('.overlay-category')
            overlay.classList.toggle('open')
        },
        toggleBurger: function () {
            const burgerDeluxe = document.getElementById('burger_deluxe2')
            burgerDeluxe.classList.toggle('open')
        },
        sendRequest: _.debounce(function () {
            // Create request payload, ensuring category is preserved from route query
            const requestPayload = _.assign(
                {},
                this.$route.query,
                this.selectFilter,
                this.selectPrice,
                this.payload
            );

            // Ensure category is explicitly set from route query if available
            if (this.$route.query.category) {
                requestPayload.category = this.$route.query.category;
            }

            this.fetchProducts(requestPayload);
        }, 300)

    },
    computed: {
        ...mapGetters({
            getList: `category/list`,
            productList: `category/products`,
            productData: 'card/productData',
        }),

    },
    watch: {
        '$route'() {
            // Set flag to prevent infinite loops
            this._isRouteChangeHandling = true;
            // Call sendRequest directly instead of selectFilters to avoid modifying URL again
            this.sendRequest();
            this._isRouteChangeHandling = false;
        },
    },
    created() {
        this.selectFilters()

    }
}
